import { useContext, useEffect, useState } from 'react';
import { format, Locale } from 'date-fns';
import * as dateFnsLocales from 'date-fns/locale';
import { PageContext } from 'src/context/PageContext';

const resolveDateFnsLocale = (localeCode: string | undefined): Locale | undefined => {
  if (!localeCode) return undefined;
  const toKey = (code: string) =>
    code
      .split('-')
      .map((part, idx) => (idx === 0 ? part.toLowerCase() : part.toUpperCase()))
      .join('');
  const exactKey = toKey(localeCode);
  if (exactKey in dateFnsLocales) return dateFnsLocales[exactKey as keyof typeof dateFnsLocales] as Locale;
  const baseKey = toKey(localeCode.split('-')[0]);
  if (baseKey in dateFnsLocales) return dateFnsLocales[baseKey as keyof typeof dateFnsLocales] as Locale;
  return undefined;
};

export const useLocalizedDate = (date: string, dateFormat: string): string => {
  const { urlParams } = useContext(PageContext);
  const [formatted, setFormatted] = useState('');

  useEffect(() => {
    if (!date) {
      setFormatted('');
      return;
    }
    const dateLocale = resolveDateFnsLocale(urlParams?.locale);
    setFormatted(format(new Date(date), dateFormat, { locale: dateLocale }));
  }, [date, dateFormat, urlParams?.locale]);

  return formatted;
};
